module.exports = {
  PENDING: 'pending',
  DONE: 'done',
  FAILED: 'failed',
  PROCESSING: 'processing',
  PICKED: 'picked',
  DISMISSED: 'dismissed',
  PAUSED: 'paused',
};

//          +-------------------------+
//          |                         |
//          |                         v
//          |                      +------+
//          |            +-------->+ done |
//          +            +         +------+
//          +            +
//       pending +---> paused
//          +            +
//          +            +                        +-----------+
//          |            +-------->  failed  +--->+ dismissed |
//          |                          ^          +-----------+
//          |                          |
//          |                          |
//          +--------------------------+
